import React, { useEffect, useState } from "react";

import "./stylesMarkets.css";

import dayjs from "dayjs";
import { ChevronDown, ChevronUp, Filter } from "react-feather";
import { Input, Select, Switch, Table } from "antd";
import createPrivateAdminPanelInstance from "../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../api/ApiRoutes";
import RebetLoader from "../../../CommonComponents/RebetLoader/RebetLoader";
import { useSearchParams } from "react-router-dom";
import { AppStrings } from "../../../../utils/constants/AppStrings";

function Markets() {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
    false
  );

  const [searchParams] = useSearchParams();
  const eventId = searchParams.get("event-id");

  const [isApiRunning, setIsApiRunning] = useState(false);
  const [showExtraFilters, setShowExtraFilters] = useState(true);

  const [displayTable, setDisplayTable] = useState("none");

  const [selectedMarket, setSelectedMarket] = useState(null);
  const [selectedBetType, setSelectedBetType] = useState(null);
  const [selectedPreMatchLive, setSelectedPreMatchLive] = useState(null);
  const [markets, setMarkets] = useState([]);
  const betTypes = [
    {
      value: null,
      label: "All",
    },
    {
      value: "straight",
      label: "Straight",
    },
    {
      value: "parlay",
      label: "Parlay",
    },
  ];
  const preMatchLive = [
    {
      value: null,
      label: "All",
    },
    {
      value: "prematch",
      label: "Pre-Match",
    },
    {
      value: "live",
      label: "Live",
    },
  ];

  const [betsToShowInTable, setBetsToShowInTable] = useState([
    {
      market_name: "",
      selections: [],
    },
  ]);

  const columns = [
    {
      title: "Selection",
      dataIndex: "selection_name",
      key: "selection_name",
      sorter: (a, b) => a.selection_name - b.selection_name,
    },
    {
      title: "Stake",
      dataIndex: "total_stake",
      key: "total_stake",
      render: (text, record) => {
        return (
          <div>
            {record.total_stake.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </div>
        );
      },
      sorter: (a, b) => a.total_stake - b.total_stake,
    },
    {
      title: "Odds",
      dataIndex: "odds",
      key: "odds",
      render: (text, record) => {
        return (
          <p>
            {Intl.NumberFormat("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(record.odds)}
          </p>
        );
      },
      sorter: (a, b) => a.odds - b.odds,
    },
    {
      title: "Probability",
      dataIndex: "probability",
      key: "probability",
      render: (text, record) => {
        return <p>{record.probability > 100 ? 100 : record.probability}%</p>;
      },
      sorter: (a, b) => a.probability - b.probability,
    },
    {
      title: "P/L",
      dataIndex: "total_pl",
      key: "total_pl",
      render: (text, record) => {
        return (
          <div
            style={{
              color:
                record.total_pl > 0
                  ? "#71BF8A"
                  : record.total_pl === 0
                  ? "#92929E"
                  : "#FF5252",
            }}
          >
            {record.total_pl.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </div>
        );
      },
      sorter: (a, b) => a.total_pl - b.total_pl,
    },
    {
      title: "Payout",
      dataIndex: "payout",
      key: "payout",
      render: (text, record) => {
        return (
          <div>
            {record.payout.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </div>
        );
      },
      sorter: (a, b) => a.payout - b.payout,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => {
        return (
          <div
            className={`event-details-markets-status ${record?.status?.toLowerCase()}`}
          >
            {record.status}
          </div>
        );
      },
    },
    {
      title: "Bets",
      dataIndex: "number_of_bets",
      key: "number_of_bets",
      sorter: (a, b) => a.number_of_bets - b.number_of_bets,
    },
  ];

  const getMarketsFilters = async () => {
    const params = {
      event_id: eventId,
    };

    try {
      setIsApiRunning(true);

      const response = await PrivateAdminPanelInstance.post(
        API_ROUTES.GET_EVENT_DETAILS_DATA,
        params
      );

      if (response?.data?.data) {
        const data = response.data.data;
        
        // Get available markets from the response
        if (data.available_markets) {
          const availableMarkets = data.available_markets.map((market) => ({
            label: market,
            value: market,
          }));
          setMarkets(availableMarkets);
        }

        // Process markets data
        if (data.markets) {
          const marketsData = data.markets || [];
          const grouped = Object.values(
            marketsData.reduce((acc, curr) => {
              const key = curr.market_name;
              if (key === "ALL SELECTED MARKETS") {
                return acc;
              }
    
              if (!acc[key]) {
                acc[key] = {
                  market_name: curr.market_name,
                  selections: [],
                };
              }
    
              acc[key].selections.push(curr);
              return acc;
            }, {})
          ).map((group) => {
            const totals = group.selections.reduce(
              (sum, item) => {
                sum.odds += item.odds;
                sum.probability += item.probability;
                sum.total_stake += item.total_stake;
                sum.total_pl += item.total_pl;
                sum.margin += item.margin;
                sum.payout += item.payout;
                sum.number_of_bets += item.number_of_bets;
                return sum;
              },
              {
                odds: 0,
                probability: 0,
                total_stake: 0,
                total_pl: 0,
                margin: 0,
                payout: 0,
                number_of_bets: 0,
              }
            );
    
            group.selections.push({
              market_name: "All Selections",
              selection_name: "All Selections",
              ...totals,
              status: null,
            });
    
            return group;
          });
    
          setBetsToShowInTable(grouped);
          setDisplayTable("flex");
        }
      }
    } catch (error) {
      console.log("Error getting markets filters:", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  const getMarkets = async () => {
    const params = {
      event_id: eventId,
      market_filter: selectedMarket,
      status: selectedPreMatchLive,
      bet_type: selectedBetType,
    };

    try {
      setIsApiRunning(true);
      const response = await PrivateAdminPanelInstance.post(
        API_ROUTES.GET_EVENT_DETAILS_DATA,
        params
      );

      const data = response?.data?.data?.markets || [];
      const grouped = Object.values(
        data.reduce((acc, curr) => {
          const key = curr.market_name;
          if (key === "ALL SELECTED MARKETS") {
            return acc;
          }

          if (!acc[key]) {
            acc[key] = {
              market_name: curr.market_name,
              selections: [],
            };
          }

          acc[key].selections.push(curr);
          return acc;
        }, {})
      ).map((group) => {
        const totals = group.selections.reduce(
          (sum, item) => {
            sum.odds += item.odds;
            sum.probability += item.probability;
            sum.total_stake += item.total_stake;
            sum.total_pl += item.total_pl;
            sum.margin += item.margin;
            sum.payout += item.payout;
            sum.number_of_bets += item.number_of_bets;
            return sum;
          },
          {
            odds: 0,
            probability: 0,
            total_stake: 0,
            total_pl: 0,
            margin: 0,
            payout: 0,
            number_of_bets: 0,
          }
        );

        group.selections.push({
          market_name: "All Selections",
          selection_name: "All Selections",
          ...totals,
          status: null,
        });

        return group;
      });

      setBetsToShowInTable(grouped);
      setDisplayTable("flex");
    } catch (error) {
      console.log("Error adding event code:", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  const handleMarketChange = (value) => {
    setSelectedMarket(value);
  };

  const handleBetTypeChange = (value) => {
    setSelectedBetType(value);
  };

  const handlePreMatchLiveChange = (value) => {
    setSelectedPreMatchLive(value);
  };

  const handleClearFilters = () => {
    setSelectedMarket(null);
    setSelectedBetType(null);
    setSelectedPreMatchLive(null);
  };

  const handleApplyFilters = () => {
    getMarkets();
  };

  useEffect(() => {
    getMarketsFilters();
  }, []);

  return (
    <div className="event-details-markets-container">
      <div className="event-details-markets">
        <>
          <div className="event-details-markets-content">
            <div className="event-details-markets-content-header">
              <div className="event-details-markets-autocomplete-container">
                <div
                  className="filter-buttons"
                  onClick={() => setShowExtraFilters(!showExtraFilters)}
                >
                  <Filter className="filter-icon" />
                  {showExtraFilters ? (
                    <ChevronUp className="filter-icon" />
                  ) : (
                    <ChevronDown className="filter-icon" />
                  )}
                </div>
              </div>
            </div>
            <div
              className="event-details-markets-selectors"
              style={{ display: showExtraFilters ? "flex" : "none" }}
            >
              <div className="event-details-markets-selector">
                <span>{AppStrings.MARKET}</span>
                <Select
                  mode="multiple"
                  style={{ width: "100%" }}
                  placeholder="Not Selected"
                  value={selectedMarket}
                  onChange={handleMarketChange}
                  options={markets}
                />
              </div>
              <div className="event-details-markets-selector">
                <span>{AppStrings.PRE_MATCH_LIVE}</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedPreMatchLive}
                  onChange={(value) => handlePreMatchLiveChange(value)}
                  options={preMatchLive}
                />
              </div>
              <div className="event-details-markets-selector">
                <span>{AppStrings.BET_TYPE}</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedBetType}
                  onChange={(value) => handleBetTypeChange(value)}
                  options={betTypes}
                />
              </div>
            </div>
            <div
              className="event-details-markets-selector-action-buttons"
              style={{ display: showExtraFilters ? "flex" : "none" }}
            >
              <button className="clear" onClick={() => handleClearFilters()}>
                {AppStrings.CLEAR_FILTERS}
              </button>
              <button className="apply" onClick={() => handleApplyFilters()}>
                {AppStrings.APPLY}
              </button>
            </div>
            {isApiRunning ? (
              <div className="event-details-markets-loader-container">
                <RebetLoader height={"100px"} width={"100px"} />
              </div>
            ) : (
              <div
                className="event-details-markets-table"
                style={{ display: displayTable }}
              >
                {betsToShowInTable.map((market, index) => (
                  <div className="event-details-markets-table-container">
                    <div
                      className="event-details-markets-table-header"
                      key={market.market_name + index}
                    >
                      <h3>{market.market_name}</h3>
                    </div>

                    <Table
                      columns={columns}
                      dataSource={market.selections}
                      pagination={false}
                      rowKey={(record) => record.bet_id}
                      sticky
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      </div>
    </div>
  );
}

export default Markets;
